export default __webpack_public_path__ + "3b65190bd238434fa592cad74728a63b.png";